// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../lastDayOfDecade/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var lastDayOfDecade = convertToFP(fn, 1);
export default lastDayOfDecade;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/lastDayOfDecade/index.js
// module id = 948
// module chunks = 0